import { useAuth0 } from '@auth0/auth0-react'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { Pages } from '../Pages'
import LoadingSpinner from '../components/LoadingSpinner'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHexagonNodes } from '@fortawesome/free-solid-svg-icons'
import Button from '../components/Button'

function Login2(): React.JSX.Element {
    const { isAuthenticated, isLoading, error, loginWithRedirect } = useAuth0()
    const navigate = useNavigate()

    useEffect(() => {
        if (!error && !isLoading && isAuthenticated) {
            navigate(Pages.Roles)
        }
    }, [error, isLoading, isAuthenticated, navigate])

    if (error) {
        return (
            <div>
                There was an error authenticating the user... {error.message}
            </div>
        )
    }

    if (isLoading) {
        return <LoadingSpinner />
    }

    // there's no error and Auth0 isn't loading any more - are we authenticated?
    if (isAuthenticated) {
        return <LoadingSpinner />
    }

    return (
        <div className="flex min-h-screen">
            {/* Left Side */}
            <div className="flex-1 bg-gradient-to-br from-ctxt-blue via-gray-900 to-gray-800 text-white flex flex-col justify-center items-center">
                <div className="px-8 max-w-lg text-center">
                    {/* <img
                        src="/logo-bg-transparent.png"
                        alt="Contxt Logo"
                        className="h-16 mb-8 bg-white p-2 rounded-lg"
                    /> */}
                    <div className="flex items-center justify-center m-3 mb-12">
                        <div>
                            <FontAwesomeIcon
                                icon={faHexagonNodes}
                                className="text-white bg-ctxt-blue text-6xl mr-2 p-2 rounded-lg"
                            />
                        </div>
                        <div className="text-7xl text-white font-open-sans-soft">
                            Cont<span className="text-blue-600">x</span>t
                        </div>
                    </div>
                    <h1 className="text-4xl font-bold mb-4">
                        Join the Talent Revolution
                    </h1>
                    <p className="text-lg text-gray-300 mb-8">
                        Contxt is changing the way we think about talent
                        management using knowledge graphs and AI.
                    </p>
                    <div className="flex justify-center space-x-4">
                        <button
                            className="bg-blue-600 hover:bg-blue-700 text-white py-2 px-6 rounded-lg"
                            onClick={() => {
                                window.location.href =
                                    'https://contxt.network/contact/'
                            }}
                        >
                            Book a Demo
                        </button>
                        <button
                            className="border border-blue-600 hover:bg-blue-600 hover:text-white text-blue-600 py-2 px-6 rounded-lg"
                            onClick={() => {
                                window.location.href = 'https://contxt.network/'
                            }}
                        >
                            Find Out More
                        </button>
                    </div>
                </div>
            </div>

            {/* Right Side */}
            <div className="flex-1 bg-white flex flex-col justify-center items-center p-8">
                <div className="max-w-md w-full">
                    <h2 className="text-2xl font-bold text-center mb-6">
                        Welcome Back
                    </h2>
                    <Button
                        style="primary"
                        type="button"
                        classes="w-full"
                        onClick={() =>
                            loginWithRedirect({
                                appState: {
                                    returnTo: Pages.Roles,
                                },
                            })
                        }
                    >
                        Login
                    </Button>
                    {/* <button
                        className="bg-blue-900 text-white font-semibold py-2 px-4 rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-700 focus:ring-offset-2 w-full"
                        onClick={() =>
                            loginWithRedirect({
                                appState: {
                                    returnTo: Pages.Roles,
                                },
                            })
                        }
                    >
                        Log In
                    </button> */}
                    {/* <form>
                        <div className="mb-4">
                            <label
                                htmlFor="email"
                                className="block text-sm font-medium text-gray-700 mb-2"
                            >
                                Email
                            </label>
                            <input
                                type="email"
                                id="email"
                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                placeholder="Enter your email"
                            />
                        </div>
                        <div className="mb-6">
                            <label
                                htmlFor="password"
                                className="block text-sm font-medium text-gray-700 mb-2"
                            >
                                Password
                            </label>
                            <input
                                type="password"
                                id="password"
                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                placeholder="Enter your password"
                            />
                        </div>
                        <button
                            type="submit"
                            className="w-full py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg text-sm font-medium focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                        >
                            Log In
                        </button>
                    </form>
                    <p className="text-sm text-center text-gray-500 mt-4">
                        Don't have an account?{' '}
                        <a href="#" className="text-blue-600 hover:underline">
                            Sign Up
                        </a>
                    </p> */}
                </div>
            </div>
        </div>
    )
}

export default Login2
